export const formatCurrency = (value?: number | null, maximumFractionDigits: number = 2) => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { style: "currency", currency: "AUD", maximumFractionDigits: maximumFractionDigits });
};

export const formatPercentage = (value?: number | null): string => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { style: "percent", maximumFractionDigits: 0 });
};

export const formatNumber = (value?: number | null): string => {
    if (value === null || value === undefined) {
        return "-";
    }

    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

export const isDefinedNumber = (value: number | null | undefined): value is number => {
    return value !== null && value !== undefined;
};

export const toNullableNumberValue = (value: unknown): number | null => typeof value === "number" ? value : null;

export const toNumberValue = (value: unknown): number => typeof value === "number" ? value : 0;

export const truncateToDecimalPlaces = (value: number, decimalPlaces: number, roundUp: boolean = false): number => {
    const factor = 10 ** decimalPlaces;
    return roundUp ? Math.ceil(value * factor) / factor : Math.trunc(value * factor) / factor;
};

export const formatDecimal = (value: number, decimalPlaces: number = 1, roundUp: boolean = false): string => {
    return truncateToDecimalPlaces(value, decimalPlaces, roundUp).toFixed(decimalPlaces);
};

export const formatToScaledRoundedThousands = (value: number) => {
    return `${formatDecimal(value / 1000, 1, true)}K`;
};

export const formatSignedPercentChange = (previousValue: number, nextValue: number): string => {
    if (previousValue === 0) {
        return nextValue === 0 ? "(0%)" : "-";
    }
    const percentChange = ((nextValue - previousValue) / previousValue) * 100;
    const truncatedPercent = Math.trunc(percentChange);
    const sign = truncatedPercent > 0 ? "+" : "";
    return `(${sign}${truncatedPercent}%)`;
};

export const sumNullable = (values: Array<number | null | undefined>): number | null => {
    const definedValues = values.filter(isDefinedNumber);

    if (definedValues.length === 0) {
        return null;
    }

    return definedValues.reduce<number>(
        (total: number, value: number): number => total + value,
        0
    );
};
